// @flow

import LabelText from './labelText';
import Text from './labelText.styled';

export {
  Text,
};

export default LabelText;
